import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";

import { EntityType } from "@mapmycustomers/shared/enum";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import ColumnPane from "@app/component/SelectColumnsPane/ColumnPane";
import { updateDrillDownViewState } from "@app/scene/dashboard/store/stackRank/actions";
import DrillDownViewState from "@app/scene/dashboard/store/stackRank/DrillDownViewState";
import { getDrillDownViewState } from "@app/scene/dashboard/store/stackRank/selectors";
import { RootState } from "@app/store/rootReducer";
import ColumnVisibility from "@app/types/viewModel/ColumnVisibility";

interface Props {
  drillDownViewState: DrillDownViewState;
  onHide: () => void;
  onUpdateDrillDownViewState?: (payload: Partial<DrillDownViewState>) => void;
  rankingMetric?: IField;
}

const SelectColumnsPane: React.FC<Props> = ({
  drillDownViewState,
  onHide,
  onUpdateDrillDownViewState,
  rankingMetric,
}) => {
  const fixedFields = useMemo(() => (rankingMetric ? [rankingMetric] : []), [rankingMetric]);

  const handleUpdate = useCallback(
    (visibilities: ColumnVisibility[]) => {
      const fieldNameToVisibility = new Map(visibilities.map((v) => [v.field.name, v.visible]));
      const updatedColumns = drillDownViewState.columns.map((column) => ({
        ...column,
        visible:
          column.field.hasFeature(FieldFeature.ALWAYS_VISIBLE) ||
          (fieldNameToVisibility.get(column.field.name) ?? column.visible),
      }));
      onUpdateDrillDownViewState?.({ columns: updatedColumns });
    },
    [onUpdateDrillDownViewState, drillDownViewState.columns]
  );

  return (
    <ColumnPane
      columns={drillDownViewState.columns}
      entityType={EntityType.LEADERBOARD}
      fixedFields={fixedFields}
      onHide={onHide}
      onUpdate={handleUpdate}
      showCategories={false}
      visible
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  drillDownViewState: getDrillDownViewState(state),
});

const mapDispatchToProps = {
  onUpdateDrillDownViewState: updateDrillDownViewState,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectColumnsPane);
